import React, { useEffect } from 'react'
import HomeGames from '../../Components/HomeGames/HomeGames'
import ViewMaster from '../../Components/ViewMaster/ViewMaster'

function Home() {
  useEffect(() => {
    document.title = "Mobiz Games | Play free games online";
  }, [])
  return (
    <>
        <div>
            <HomeGames />
        </div>
    </>
  )
}

export default ViewMaster(Home)